import React from "react";

// ==============================================================================
// ERROR BOUNDARY
// Without this, any throw anywhere in a builder unmounts the whole tree and the
// customer is left looking at an empty div with no message and nothing to do.
// The most likely cause is a corrupt value in localStorage, which repeats on
// every visit for that one browser profile, so the fallback offers a reset that
// clears this builder's own keys and reloads without the share-link query.
// ==============================================================================
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surfaces in the browser console for support calls.
    console.error("ANR Builder error:", error, info);
  }

  handleReset = () => {
    try {
      Object.keys(localStorage)
        .filter((k) => k.startsWith("anr_"))
        .forEach((k) => localStorage.removeItem(k));
    } catch (e) {
      // Storage blocked entirely - reloading clean is still worth a try.
    }
    // Drops any ?config= share payload along with the saved draft.
    window.location.href = window.location.pathname;
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{ padding: "25px", backgroundColor: "#1e1e1e", border: "1px solid #444", borderRadius: "4px", color: "#ccc", fontSize: "14px", lineHeight: "1.6", maxWidth: "620px", margin: "30px auto" }}>
        <strong style={{ color: "#D5A678", display: "block", marginBottom: "8px", fontSize: "16px" }}>The Builder Could Not Load</strong>
        <p style={{ margin: "0 0 16px 0" }}>
          Something went wrong starting the configurator, usually a saved draft from a
          previous visit. Resetting clears that draft and starts you fresh. Your cart
          is not affected.
        </p>
        <button
          onClick={this.handleReset}
          style={{ backgroundColor: "transparent", color: "#D5A678", border: "1px solid #D5A678", borderRadius: "4px", padding: "10px 18px", fontSize: "14px", fontWeight: "bold", textTransform: "uppercase", cursor: "pointer" }}
        >
          Reset Builder
        </button>
        <p style={{ margin: "16px 0 0 0", fontSize: "13px", color: "#888" }}>
          Still stuck? Email{" "}
          <a href="mailto:info@anrkydexholsters.com" style={{ color: "#D5A678" }}>info@anrkydexholsters.com</a>{" "}
          and we will build it with you.
        </p>
      </div>
    );
  }
}

export default ErrorBoundary;
